export const ADD_IDENTIFY_REQUEST = 'ADD_IDENTIFY_REQUEST'
export const REMOVE_IDENTIFY_REQUEST = 'REMOVE_IDENTIFY_REQUEST'
export const IDENTIFY_REQUESTS_IN_PROGRESS = 'IDENTIFY_REQUESTS_IN_PROGRESS'
